import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { SUPPORTED_LANGUAGES } from "../tools/i18n/locales";
import { USER_LANGUAGE_STORAGE_KEY, hasUserSelectedLanguage } from "./utils/userLanguage";

// Функція для отримання мови з Telegram WebApp
const getTelegramLanguage = (): string | undefined => {
    try {
        const tg = window.Telegram?.WebApp;
        // Мова знаходиться в initDataUnsafe.user.language_code
        const languageCode = tg?.initDataUnsafe?.user?.language_code;
        
        if (languageCode) {
            const tgLang = languageCode.toLowerCase();
            
            // Перевіряємо, чи підтримується ця мова
            // Спробуємо знайти точний збіг або базову мову (наприклад, "pt-BR" -> "pt")
            if (SUPPORTED_LANGUAGES.includes(tgLang)) {
                return tgLang;
            }
            // Якщо мова з регіоном (наприклад, "pt-BR"), спробуємо базову мову
            const baseLang = tgLang.split("-")[0];
            if (SUPPORTED_LANGUAGES.includes(baseLang)) {
                return baseLang;
            }
        }
    } catch {
        // Telegram WebApp недоступний (наприклад, не в Telegram)
        // Тихий fallback без логування
    }
    return undefined;
};

i18next
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: "en",
        debug: false,

        detection: {
            // Порядок перевірки джерел мови
            // localStorage має найвищий пріоритет (якщо користувач вручну вибрав мову)
            order: [
                "localStorage",      // 1. Спочатку перевіряємо, чи користувач вручну вибрав мову
                "querystring",        // 2. Параметр ?lng= в URL
                "navigator",          // 3. Мова браузера
                "htmlTag",            // 4. HTML lang атрибут
                "cookie",             // 5. Cookie
            ],
            lookupLocalStorage: USER_LANGUAGE_STORAGE_KEY,
            caches: ["localStorage"], // Зберігаємо мову в localStorage
        },

        backend: {
            loadPath: "/locales/{{lng}}.json",
        },

        interpolation: {
            escapeValue: false,
        },

        keySeparator: false,
        returnNull: false
    });

// Після ініціалізації перевіряємо мову Telegram, якщо немає збереженої мови
i18next.on("initialized", () => {
    // Перевіряємо, чи є збережена мова в localStorage (якщо користувач вручну вибрав мову)
    // Якщо немає збереженої мови, використовуємо мову Telegram
    // (якщо є збережена мова, вона вже встановлена через LanguageDetector і має пріоритет)
    if (!hasUserSelectedLanguage()) {
        const tgLang = getTelegramLanguage();
        if (tgLang) {
            // Встановлюємо мову Telegram (якщо вона підтримується)
            i18next.changeLanguage(tgLang).catch(() => {
                // Якщо мова не підтримується або сталася помилка, fallback на "en"
                i18next.changeLanguage("en");
            });
        } else {
            // Якщо Telegram WebApp недоступний, використовуємо fallback "en"
            i18next.changeLanguage("en");
        }
    }
    });

export default i18next;
